module.exports = "/add_event-485d224f9fc77c6653188dfb8d43f86c.svg";